module.exports = __webpack_public_path__ + "img/facebook.813081f6.png";